import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { InvoicesService } from '../services/invoices.service';
import { Invoice } from '../../models/invoice';
import { InvoiceFilter } from '../../models/invoice-filter';
import * as moment from 'moment';

@Injectable()

/**
 * InvoicesResolver resolves request to get all invoices for the current year
 */
export class InvoicesResolver implements Resolve<Invoice[]>
{
	/**
	 * InvoicesResolver constructor
	 *
	 * @param {InvoicesService} invoicesService
	 */
	constructor(private invoicesService: InvoicesService)
	{
	}

	/**
	 * Provides data to a route
	 *
	 * @returns {Observable<Invoice[]>}
	 */
	resolve(): Observable<Invoice[]>
	{
		const filters: InvoiceFilter = {
			year: moment().year(),
			week: null,
			search: null
		};
		return this.invoicesService.getInvoices(filters);
	}
}



// WEBPACK FOOTER //
// ./src/app/invoices/resolvers/invoices.resolver.ts